export const Breakpoint = Object.freeze({
  ViewPort4: 'viewPort4',
  ViewPort9: 'viewPort9',
  ViewPort12: 'viewPort12',
});
